import { Component } from '@angular/core';
import { finalize } from 'rxjs';
import { ClienteUnicoServiceProxy, FidelidadOrderPointsDto } from '../../services/service-proxy/service-proxies';
import { AppService } from '../../services/app.service';

/** Una linea del historial, ya lista para mostrar en el resumen de la home. */
interface LineaResumen {
  fecha : Date | null;
  concepto : string;
  puntos : number;
}

@Component({
  selector: 'app-historial-reciente',
  templateUrl: './historial-reciente.component.html',
  styleUrls: ['./historial-reciente.component.scss']
})
export class HistorialRecienteComponent {

  isLoading = false;
  cargado = false;
  lineas : LineaResumen[] = [];

  constructor(private clienteUnicoService : ClienteUnicoServiceProxy,
              private appService : AppService) {}

  ngOnInit() {

    const idUnico = this.appService.idUnico;
    if (!idUnico) return;

    this.isLoading = true;
    this.clienteUnicoService
        .getFidelidadPointsOrder(idUnico)
        .pipe(finalize(() => { this.isLoading = false; this.cargado = true; }))
        .subscribe({
          next : movimientos => this.lineas = this.mapear(movimientos ?? []),
          error : () => this.lineas = []
        });
  }

  /** Las tres mas recientes, mismo criterio que el historial completo. */
  private mapear(datos : FidelidadOrderPointsDto[]) : LineaResumen[] {
    return datos
      .map(d => {
        const puntos = this.aNumero(d.puntosCompra) + this.aNumero(d.puntosPesos);
        return {
          fecha : this.aFecha(d.fecha),
          concepto : this.concepto(d.lugar, puntos),
          puntos,
        };
      })
      .sort((a, b) => (b.fecha?.getTime() ?? 0) - (a.fecha?.getTime() ?? 0))
      .slice(0, 3);
  }

  // Puntos negativos = devolucion (la API manda los puntos en negativo).
  private concepto(lugar : string | undefined, puntos : number) : string {
    const l = (lugar ?? '').trim();
    const verbo = puntos < 0 ? 'Devolución' : 'Compra';
    if (!l || /online/i.test(l)) return `${verbo} online`;
    return `${verbo} en ${l}`;
  }

  private aFecha(valor : string | undefined) : Date | null {
    if (!valor) return null;
    const d = new Date(valor);
    return isNaN(d.getTime()) ? null : d;
  }

  // Conserva el signo: las devoluciones vienen en negativo ("-1,094"). Quitar
  // [^\d] a secas se comia el "-" y las dejaba en positivo (neteaban mal).
  private aNumero(valor : string | undefined) : number {
    const s = String(valor ?? '').trim();
    if (!s) return 0;
    const negativo = s.startsWith('-');
    const digits = s.replace(/[^\d]/g, '');
    if (!digits) return 0;
    const n = Number(digits);
    return isNaN(n) ? 0 : (negativo ? -n : n);
  }

  get hayLineas() : boolean {
    return this.lineas.length > 0;
  }
}
